
<button class="btn btn-sm text-xxs border-0 rounded bg-transparent d-flex align-items-center mb-1 mt-3 btn-hover" @click="go_back_to_company_management">
  <i class="bx bx-chevron-left-circle me-2"></i>
  <span class="text-xs">Back to Companies</span>
</button>
<div class="border-card border-0 px-4 py-1 scroll-container" ref="PermissionManagement">
  <h2 class="page-title fw-bold">Permission Management</h2>

  <!-- Permissions Available Card -->
  <div class="row">
    <div class="col-md-4">
      <div class="card card-bg shadow rounded-lg border-0 h-100">
        <div class="card-body">
          <div class="d-flex justify-content-between px-md-1">
            <div>
              <p class="text-white text-x">Permissions Available</p>
              <p class="mb-0 sub_heading text-xsm text-primary-green fw-bold mt-4 fs-4">0</p>
            </div>
            <div class="text-center">
              <div class="align-self-center rounded-circle p-3 shadow circular-icon">
                <i class="fas fa-users fa-lg text-primary-green"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Permission Table Preview -->
  <div class="card rounded-lg mt-4 border-0 shadow">
    <div class="card-body">

      <!-- Toolbar Row with Assign Button -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <button 
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          @click="assign_features">
          <i class="bi bi-plus-lg"></i> Assign Features
        </button>
      </div>

      <!-- GlobalTable -->
      <GlobalTable 
        v-if="permission_list && permission_list.length > 0"
        :headers="['ID', 'Policy Name', 'Description']"
        :data="permission_list" 
        :table_id="permission_table">

        <template #actions="{ row }">
          <div class="d-flex gap-1">
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" data-bs-toggle="modal" data-bs-target="#view_policy">
              View
            </button> 
            <button class="btn btn-primary-dark btn-sm px-3 shadow-sm text-xxs" @click="delete_policy(row)">Delete Policy</button>
          </div>
        </template>

      </GlobalTable>
    </div>
  </div>
  
</div>

<!-- Vue-Only Modal -->
<teleport to="body">
<div id="view_policy" class="modal fade" tabindex="-1" aria-labelledby="create_section_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs">Policy Details</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div v-if="selected_policy" class="modal-body">
        <p class="text-xxs"><strong>Application No:</strong> {{ selected_policy['Application No'] }}</p>
        <p class="text-xxs"><strong>Policy Name:</strong> {{ selected_policy['Name and Surname'] }}</p>
        <p class="text-xxs"><strong>Date Created:</strong> {{ selected_policy['Date Created'] }}</p>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
      </div>
    </div>
  </div>
</div>
</teleport>